import { render, staticRenderFns } from "./VelocityListCard.vue?vue&type=template&id=687db30a&scoped=true&"
import script from "./VelocityListCard.vue?vue&type=script&lang=js&"
export * from "./VelocityListCard.vue?vue&type=script&lang=js&"
import style0 from "./VelocityListCard.vue?vue&type=style&index=0&id=687db30a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687db30a",
  null
  
)

export default component.exports